<!-- 服务类型 -->
<template>
  <div>
    <header class="t-blue tac pt-40">请选择服务类型</header>
    <div class="p-40">
      <div
        v-for="(item, index) in bannerViewList"
        :key="item.code"
        :class="[`banner-${index+1}`]"
        class="p-40 mb-40 tac border-radius-10 banner"
        @click="handleClickBanner(item)"
      >
        <p>{{ item.text }}</p>
        <div class="btn">立即申请</div>
      </div>
    </div>
    <CFooter></CFooter>
  </div>
</template>

<script>
import CFooter from "@/components/CFooter.vue"
import { APPLY_TYPE } from "@share/enum"
import { cleanSessions } from "@/utils/utils"
export default {
  name: "Sub",
  components: {
    CFooter,
  },
  data: () => {
    return {
      pageCode: "",
      bannerList: [
        {
          code: "2",
          children: [
            // {
            //   code: APPLY_TYPE.GZ4050SBBT,
            //   text: "广州4050社保补贴",
            // },
            {
              code: APPLY_TYPE.SGPXBT,
              text: "适岗培训补贴",
            },
            {
              code: APPLY_TYPE.SYBXWGBT,
              text: "失业保险稳岗补贴",
            },
          ],
        },
        {
          code: "3",
          children: [
            {
              code: APPLY_TYPE.ZYJSZGRD,
              text: "专业技术资格认定",
            },
            {
              code: APPLY_TYPE.ZYJSZGPS,
              text: "专业技术资格评审",
            },
            {
              code: APPLY_TYPE.ZYJSZGQR,
              text: "专业技术资格确认",
            },
          ],
        },
      ],
    }
  },
  computed: {
    bannerViewList() {
      if (this.pageCode) {
        return this.bannerList.filter((item) => {
          if (item.code === this.pageCode) {
            return item
          }
        })[0].children
      } else {
        return []
      }
    },
  },
  created() {
    cleanSessions()
  },
  mounted() {
    this.pageCode = this.$route.params.code || ""
  },
  methods: {
    handleClickBanner(item) {
      let path
      switch (item.code) {
        case APPLY_TYPE.GZ4050SBBT:
        case APPLY_TYPE.SGPXBT:
        case APPLY_TYPE.SYBXWGBT:
          path = `/apply/${item.code}`
          break
        case APPLY_TYPE.ZYJSZGRD:
        case APPLY_TYPE.ZYJSZGPS:
        case APPLY_TYPE.ZYJSZGQR:
          path = `/apply/${item.code}`
          break
      }
      this.$router.push({
        path,
      })
    },
  },
}
</script>

<style lang="scss" scope>
.banner {
  color: #fff;
  p {
    font-size: 40px;
    font-weight: bold;
  }
  .btn {
    margin-top: 40px;
    font-size: 24px;
    border-radius: 50px;
    background: #fff;
    display: inline-block;
    padding: 10px 40px;
  }
}
.banner-1 {
  background: #0986ff;
  .btn {
    color: #0986ff;
  }
}
.banner-2 {
  background: #274fe0;
  .btn {
    color: #274fe0;
  }
}
.banner-3 {
  background: #5f2adc;
  .btn {
    color: #5f2adc;
  }
}
</style>
